import { colors, fonts } from '../../theme';

const reset = {
  p: 0,
  border: 0,
  backgroundColor: 'transparent',
  fontFamily: fonts.text,
  cursor: 'pointer',
};

const row = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1.25,
  px: 2,
  py: 1.25,
};

const like = {
  ...reset,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0.25,
  minWidth: 28,
  color: colors.textSubtle,
  fontSize: 11,
  '& svg': {
    fontSize: 16,
  },
};

const styles = {
  row,
  rowReply: {
    ...row,
    pl: 7,
    py: 1,
  },
  rowHighlighted: {
    backgroundColor: colors.surfaceRaised,
    transition: 'background-color 400ms ease',
  },
  avatar: {
    width: 34,
    height: 34,
    cursor: 'pointer',
  },
  avatarReply: {
    width: 26,
    height: 26,
    cursor: 'pointer',
  },
  body: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 0.375,
  },
  userLine: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.75,
    minWidth: 0,
  },
  username: {
    ...reset,
    color: colors.textSecondary,
    fontSize: 12,
    fontWeight: 600,
  },
  message: {
    fontFamily: fonts.text,
    fontSize: 13.5,
    lineHeight: 1.4,
    color: colors.text,
    overflowWrap: 'anywhere',
  },
  mention: {
    ...reset,
    font: 'inherit',
    fontWeight: 500,
    color: colors.mention,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    fontFamily: fonts.text,
    fontSize: 11.5,
    color: colors.textSubtle,
  },
  reply: {
    ...reset,
    color: colors.textSecondary,
    fontSize: 11.5,
    fontWeight: 600,
    '&:hover': {
      color: colors.text,
    },
  },
  like,
  likeActive: {
    ...like,
    color: colors.danger,
  },
};

export default styles;
